import React from "react";
import "./Home.css";

const Home = () => {

  return (
    <div className="home">
      <div className="home-text">LAB</div>
      <img src="/images/logos/manamusic.jpeg" alt="Manamusic logo" className="home-image" />
      <div className="manamusic-text">Manamusic</div>
    </div>
  )
}

export default Home;